<template>
  <div>
  <div class="container">
        <div class="row">
            
      
             <div class="col-lg-12 col-md-12 col-sm-24 text-center">
                  <h5>Je afspraak is voorzien op :</h5><br><br>
                  <h5><strong>{{selTime.DateInfo}}</strong></h5>
                  om <br>
                  <h1>{{selTime.TimeInfo}}</h1><br>
              </div>  

               <div class="col-lg-12 col-md-12 col-sm-24 text-center" style = "text-align:center;background-color:#dedede;padding-top:10px;border-radius:10px;padding-bottom:5px;margin-bottom:10px;" v-if="this.selectedSinleStore != undefined">
                Je afspraak gaat door in salon<br>
                <div style="width:90%"><h3 style="font-weight: bold;">{{this.selectedSinleStore.UserName}}</h3></div>
                <div style="width:90%"></div>
                <div style="width:90%"><h5 style="font-weight: bold;" >{{getSalonAdres(this.selectedSinleStore.Location)}}</h5></div>
                <div class="row hidesmall">&nbsp;</div>
              </div>
              <div class="row hidesmall">&nbsp;</div>

 
             <div class="col-lg-12 col-md-12 col-sm-24 text-center">
                  Jouw afspraak komt automatisch in onze agenda. <br>
                  Je ontvangt ook nog een e-mail met de bevestiging.<br><br>
                  Indien je na 5 minuten nog geen mail hebt ontvangen, kijk ook eens in de folder van ongewenste e-mail.<br>
                  <br>
                  Bij twijfel contacteer ons telefonisch en geef datum en tijdstip door aub.<br>
                  <br>
                   <div class="product-btn" >
                       <a  class="col-lg-12 col-md-12 col-sm-24" @click="resetAppoint" v-bind:style="{ 'background-color': getColorApp, color: '#fff'}"><i ></i>OK</a>
                   </div>
              </div>  
          

            <div class="col-12" style="height:40px;">
            </div>
            <div class="row"><div class="col-24">&nbsp;</div></div>
            <div class="row"><div class="col-24">&nbsp;</div></div>
        </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import CartItem  from '../components/cart/CartItem';
  export default {
    name: 'product-list',
    props: ['products'],
    data () {
      return {
        selTime: Vue.$selectedTime,
        cart: this.$store.state.cart,
        flgShowDet : false,
        selectedSinleStore : undefined
      }
    },
    components: {
        cartItem : CartItem
    },
    mounted () {
      this.selectedSinleStore = Vue.$selectedStore;
    },
    computed: {
      getColorApp () {
           return Vue.$storeSettings.ColorApp;
       }
    },
    methods: {
      getSalonAdres (locationname) {
         var arr = locationname.split (",");
         if (arr.length > 1) return arr[1];
         return locationname;
      },
      navigate (item) {
        this.$router.push(item);
      },
      navigateBack () {
        this.$router.go(-1);
      },
      resetAppoint () {
         Vue.$selectedTime = {}
         Vue.$storeCustomer = undefined;
         this.navigate ('/');
      }
    }
  }
</script>
<style>
  .products {
    background: #F7F8FB;
    padding: 30px 0;
  }
  @media (max-width: 800px) {
      .hidesmall {
        display: none;
      }
  }
</style>



// WEBPACK FOOTER //
// src/pages/CartReservationDone.vue